import React, { useEffect, useState } from 'react';
import { GiHandTruck } from 'react-icons/gi';
import { MdLocalHotel } from 'react-icons/md';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import { PrimaryTitleGray } from '../../../app/theme/tokens/colors';
import {
  InputText,
  PrimaryButton,
  SecondaryButton,
} from '../../../shared/ui/Inputs';
import { Spinner } from '../../../shared/ui/Spinners';
import { OrderFlowTable } from '../../../shared/ui/orderFlowTable';
import { LargeTile } from '../../../shared/ui/grid/gridsystem';
import { WideLayout } from '../../../shared/layout/widelayout';
import { Panel } from '../../../shared/ui/panel/panels';
import { getCustomerBallast } from '../../../services/collection/collectionService';
import { usePortalStore } from '../../../stores/portalStore';
import { useCollectionStore } from '../store/collectionStore';
import { formatCPF } from '../../../utils/format';
import { genericOrderCode, isGenericOrder } from '../../../utils/orders';
import { ArrowForward } from '@mui/icons-material';
import { Tooltip } from '../../../shared/ui/Tooltip';
import { OrderFlowPageHeader } from '../../../shared/ui/orderFlowPageHeader';

export const groupBySegment = (list) => {
  const map = {};
  list.forEach((l) => {
    if (!map[l.segment]) {
      map[l.segment] = {
        segment: l.segment,
        data: [],
      };
    }
    map[l.segment].data.push(l);
  });
  return map;
};
const MainPanels = () => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const currentUser = usePortalStore((state) => state.currentUser);
  const selectedPatient = useCollectionStore((state) => state.selectedPatient);
  const setConfiguredCollection = useCollectionStore(
    (state) => state.setConfiguredCollection
  );
  const equipmentList = useCollectionStore((state) => state.equipmentList);
  const setEquipmentList = useCollectionStore(
    (state) => state.setEquipmentList
  );
  const collectionSelected = useCollectionStore(
    (state) => state.collectionSelected
  );
  const setCollectionSelected = useCollectionStore(
    (state) => state.setCollectionSelected
  );
  const getKeptItems = useCollectionStore((state) => state.getKeptItems);
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState(0);
  const navigate = useNavigate();
  const [eqQty, setEqQty] = useState({});
  const getEquipmentQuantity = (equipment) => Number(equipment?.qty ?? 0);
  const isEquipmentSelectable = (equipment) =>
    getEquipmentQuantity(equipment) > 0;
  useEffect(() => {
    if (!selectedPatient?.cpf) {
      navigate('/collectEquipments/collectFromPatient');
    }
  }, [selectedPatient, navigate]);

  useEffect(() => {
    if (!selectedPatient?.cpf) return;

    //buscar todos os equipamentos alocados no cliente
    (async () => {
      setIsLoading(true);
      let equipments = await getCustomerBallast(
        selectedPatient.cpf,
        selectedPatient.cnpj
      );
      equipments = equipments
        .filter((x) => x.segment.toLowerCase() !== 'descartável')
        .sort((equip1, equip2) => {
          const text = 'Acessórios';
          const equip1SubCat = equip1.subCategory;
          const equip2SubCat = equip2.subCategory;
          const hasText1 = equip1SubCat?.includes(text);
          const hasText2 = equip2SubCat?.includes(text);
          if (hasText1 && !hasText2) {
            return 1;
          } else if (!hasText1 && hasText2) {
            return -1;
          } else {
            return 0;
          }
        });

      // Add generic order to the list
      equipments.push({
        category: 'Oxigenoterapia',
        name: 'Validação e Processamento de Pedidos',
        id: genericOrderCode,
        segment: 'Equipamento',
        subCategory: 'Conector e válvulas para circuito respiratório',
        qty: 1,
        accessories: [],
      });

      setConfiguredCollection(null);
      const mapAccEq = {};
      equipments.forEach((eq, idx) => {
        eq.accessories = eq.accessories[0] ? eq.accessories[0] : [];
        eqQty[eq.id] = eq.qty;
        mapAccEq[eq.id] = {
          parent: false,
        };
      });

      setCollectionSelected(mapAccEq);
      setEquipmentList(equipments);
      setIsLoading(false);
    })();
  }, [selectedPatient?.cpf, selectedPatient?.cnpj]);

  if (!selectedPatient?.cpf) {
    return (
      <div
        style={{
          width: '100%',
          minHeight: '60vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Spinner />
      </div>
    );
  }

  const selectEquipment = (id, checked) => {
    const idInt = parseInt(id, 10);
    const equipment = equipmentList.filter(
      (x) => x.id === idInt || x.id === id
    )[0];
    if (!isEquipmentSelectable(equipment)) return;
    if (checked && equipment.accessories.length > 0) {
      //tem q checar todos os filhos
      const clone = JSON.parse(JSON.stringify(collectionSelected));
      const mapAcc = {};
      equipment.accessories.forEach((acc) => {
        if (clone[acc.id]) {
          clone[acc.id].parent = true;
        }
      });
      mapAcc.parent = checked;
      clone[id] = mapAcc;
      setCollectionSelected(clone);
    } else {
      const clone = JSON.parse(JSON.stringify(collectionSelected));
      clone[id].parent = checked;
      if (equipment.accessories.length > 0) {
        equipment.accessories.forEach((acc) => {
          if (clone[acc.id]) {
            clone[acc.id].parent = checked;
          }
        });
      }
      setCollectionSelected(clone);
    }
  };
  const selectGenericEquipment = () => {
    //Workaround begin
    const checked = false;
    const clone = JSON.parse(JSON.stringify(collectionSelected));
    equipmentList.forEach((eq) => {
      const id = eq.id;
      const idInt = parseInt(id, 10);
      const equipment = equipmentList.find(
        (x) => x.id === idInt || x.id === id
      );
      if (equipment) {
        if (checked && equipment.accessories.length > 0) {
          const mapAcc = {};
          equipment.accessories.forEach((acc) => {
            if (clone[acc.id]) {
              clone[acc.id].parent = true;
            }
          });
          mapAcc.parent = checked;
          clone[id] = mapAcc;
        } else {
          clone[id].parent = checked;
          if (equipment.accessories.length > 0) {
            equipment.accessories.forEach((acc) => {
              if (clone[acc.id]) {
                clone[acc.id].parent = checked;
              }
            });
          }
        }
      }
    });
    //Workaround end
    const id = genericOrderCode;
    clone[id].parent = true;
    setCollectionSelected(clone);
  };
  const uncheckItem = (eqId, id, checked) => {
    const clone = JSON.parse(JSON.stringify(collectionSelected));
    clone[eqId][id] = checked;
    setCollectionSelected(clone);
  };

  const moveNextToResume = () => {
    const collect = [];
    equipmentList.forEach((eq) => {
      if (!isGenericOrder(eq.id))
        eq.collect = collectionSelected[eq.id]?.parent;
      else {
        eq.collect = false;
      }
      if (!eq.collect) {
        eq.qty = eqQty[eq.id];
      }
    });
    equipmentList.forEach((eq) => {
      const c = { ...eq };
      c.accessories = eq.accessories.filter((x) => x.collect === true);

      if (c.accessories.length > 0 || c.collect === true) {
        collect.push(c);
      }
    });
    setConfiguredCollection(collect);
    navigate('/collectEquipments/finishCollectEquipments');
  };

  const moveNextToResumeGeneric = () => {
    const collect = [];
    collect.push({
      category: 'Oxigenoterapia',
      name: 'Validação e Processamento de Pedidos',
      id: genericOrderCode,
      segment: 'Equipamento',
      subCategory: 'Conector e válvulas para circuito respiratório',
      qty: 1,
      accessories: [],
    });
    setConfiguredCollection(collect);
    navigate('/collectEquipments/finishCollectEquipments');
  };

  const shouldShowProceed = () => {
    return (
      JSON.stringify(collectionSelected).toLowerCase().indexOf('true') >= 0
    );
  };
  const toggleTableQuantity = (valor, id, idx) => {
    if (valor <= eqQty[id] && valor > 0 && collectionSelected[id].parent) {
      equipmentList[idx].qty = valor;
      setEquipmentList(equipmentList);
    }
  };

  const getMergedEquipmentList = () => {
    const formatSerialNumber = (value) => {
      const raw = String(value ?? '').trim();
      if (raw === '') return '-';

      const normalized = raw.replace(',', '.');
      const parsed = Number(normalized);
      if (Number.isFinite(parsed) && parsed === 0) return '-';

      return raw;
    };

    const list = equipmentList
      .filter((x) => !isGenericOrder(x.id))
      .map((equipment, idx) => {
        return [
          {
            select: (
              <input
                type="checkbox"
                checked={
                  isEquipmentSelectable(equipment)
                    ? collectionSelected[equipment.id].parent ?? false
                    : false
                }
                disabled={!isEquipmentSelectable(equipment)}
                onChange={(e) =>
                  selectEquipment(e.target.value, e.target.checked)
                }
                value={equipment.id}
              />
            ),
            name: equipment.name,
            category: equipment.category,
            subCategory: equipment.subCategory,
            serialNumber: formatSerialNumber(equipment.serialNumber),
            qty: (
              <InputText
                type="number"
                value={equipment.qty}
                min={1}
                max={eqQty[equipment.id]}
                onChange={(e) =>
                  toggleTableQuantity(e.target.value, equipment.id, idx)
                }
              ></InputText>
            ), //equipment.qty,
          } /* ,equipment.accessories.map(acc => {
            return {
                select:<input type="checkbox" onChange={(e)=>uncheckItem(equipment.id,e.target.value,e.target.checked)} value={acc.id} checked={collectionSelected[equipment.id][acc.id] ?? false} />,
                name: acc.name,
                category: acc.category,
                subCategory: acc.subCategory,
                serialNumber: acc.serialNumber,
                qty:acc.qty
            }
        }) */,
        ];
      });
    return list.flat().flat();
  };
  const toggleAll = (checked) => {
    const clone = JSON.parse(JSON.stringify(collectionSelected));
    equipmentList.forEach((eq) => {
      const id = eq.id;
      const idInt = parseInt(id, 10);
      const equipment = equipmentList.find(
        (x) => x.id === idInt || x.id === id
      );
      if (equipment && isEquipmentSelectable(equipment)) {
        if (checked && equipment.accessories.length > 0) {
          const mapAcc = {};
          equipment.accessories.forEach((acc) => {
            if (clone[acc.id]) {
              clone[acc.id].parent = true;
            }
          });
          mapAcc.parent = checked;
          clone[id] = mapAcc;
        } else {
          clone[id].parent = checked;
          if (equipment.accessories.length > 0) {
            equipment.accessories.forEach((acc) => {
              if (clone[acc.id]) {
                clone[acc.id].parent = checked;
              }
            });
          }
        }
      }
    });
    setCollectionSelected(clone);
  };
  const configCollection = () => {
    return (
      <>
        <div style={{ overflow: 'auto' }}>
          {!isLoading ? (
            equipmentList.filter((x) => !isGenericOrder(x.id)).length > 0 ? (
              <OrderFlowTable
                ariaLabel="Equipamentos disponíveis para recolhimento"
                header={[
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '2px',
                    }}
                  >
                    <input
                      onClick={(e) => toggleAll(e.target.checked)}
                      type="checkbox"
                      title="Selecionar todos"
                    />
                    <span
                      style={{
                        fontSize: '10px',
                        fontWeight: 600,
                        lineHeight: '11px',
                        textAlign: 'center',
                      }}
                    >
                      Selecionar
                      <br />
                      Todos
                    </span>
                  </div>,
                  'Equipamentos e Acessórios',
                  'Categoria',
                  'Subcategoria',
                  'Nº Serie',
                  'Qtd',
                ]}
                data={getMergedEquipmentList()}
              ></OrderFlowTable>
            ) : (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '40px 20px',
                  gap: '10px',
                  color: PrimaryTitleGray,
                  textAlign: 'center',
                }}
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                <p
                  style={{
                    margin: 0,
                    fontSize: '13px',
                    lineHeight: '1.6',
                    maxWidth: '420px',
                  }}
                >
                  Este paciente não possui equipamentos e acessórios para serem
                  recolhidos.
                </p>
              </div>
            )
          ) : (
            <div
              style={{
                width: '100%',
                textAlign: 'center',
                overflow: 'hidden',
                padding: '20px',
                boxSizing: 'border-box',
              }}
            >
              <Spinner></Spinner>
            </div>
          )}
        </div>
        <div style={{ height: '100px' }}></div>
      </>
    );
  };

  const confirmChanges = () => {
    const keptItemsCount = getKeptItems().filter(
      (x, idx) =>
        (x.collect === false || (x.collect === true && x.qty < eqQty[x.id])) &&
        !isGenericOrder(x.id)
    ).length;

    return (
      <div style={{ position: 'relative', fontSize: '14px' }}>
        <div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              borderBottom: 'solid 1px #ccc',
              marginBottom: '5px',
            }}
          >
            <MdLocalHotel
              style={{ fontSize: '25px', marginRight: '9px', color: '#318300' }}
            ></MdLocalHotel>
            <div style={{ fontSize: '16px' }}>
              {keptItemsCount === 0
                ? 'Nenhum item será mantido'
                : keptItemsCount === 1
                ? 'Item que será mantido'
                : 'Itens que serão mantidos'}
            </div>
          </div>
          <div>
            <ul style={{ margin: '0', padding: '0' }}>
              {Object.values(
                groupBySegment(
                  getKeptItems().filter(
                    (x, idx) =>
                      (x.collect === false ||
                        (x.collect === true && x.qty < eqQty[x.id])) &&
                      !isGenericOrder(x.id)
                  )
                )
              ).map((ss, idx) => (
                <li style={{ listStyle: 'none' }} key={idx}>
                  <p>{ss.segment}</p>
                  {ss.data.map((acc, j) => (
                    <div
                      style={{
                        listStyle: 'none',
                        padding: '6px 15px',
                        background: '#efefef',
                        borderRadius: '10px',
                        marginBottom: '5px',
                        marginLeft: '35px',
                      }}
                      key={j}
                    >
                      {eqQty[acc.id] !== acc.qty &&
                      collectionSelected[acc.id].parent
                        ? eqQty[acc.id] - acc.qty
                        : eqQty[acc.id]}
                      x {acc.name}
                    </div>
                  ))}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              borderBottom: 'solid 1px #ccc',
              marginBottom: '5px',
              marginTop: '10px',
            }}
          >
            <GiHandTruck
              style={{ fontSize: '30px', marginRight: '9px', color: '#b34141' }}
            ></GiHandTruck>
            <div style={{ fontSize: '16px' }}>
              {getKeptItems().filter(
                (x) => x.collect === true && !isGenericOrder(x.id)
              ).length > 1 ? (
                <div style={{ fontSize: '16px' }}>
                  Itens que serão recolhidos
                </div>
              ) : (
                <div style={{ fontSize: '16px' }}>Item que será recolhido</div>
              )}
            </div>
          </div>
          <div>
            <ul style={{ margin: '0', padding: '0' }}>
              {Object.values(
                groupBySegment(
                  getKeptItems().filter(
                    (x) => x.collect === true && !isGenericOrder(x.id)
                  )
                )
              ).map((ss, idx) => (
                <li style={{ listStyle: 'none' }} key={idx}>
                  <p>{ss.segment}</p>
                  {ss.data.map((acc, j) => (
                    <div
                      style={{
                        listStyle: 'none',
                        padding: '6px 15px',
                        background: '#efefef',
                        borderRadius: '10px',
                        marginBottom: '5px',
                        marginLeft: '35px',
                      }}
                      key={j}
                    >
                      {acc.qty}x {acc.name}
                    </div>
                  ))}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '25px',
          }}
        >
          <div style={{ width: '150px' }}>
            <SecondaryButton onClick={() => setStep(0)}>Voltar</SecondaryButton>
          </div>
          <div style={{ marginLeft: '15px' }}>
            <PrimaryButton
              onClick={() => {
                selectEquipment(genericOrderCode, false);
                moveNextToResume();
              }}
            >
              Prosseguir
            </PrimaryButton>{' '}
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      <LargeTile margin={'15px'}>
        {step === 0 ? (
          <OrderFlowPageHeader
            title="Recolhimento"
            subtitle={`Solicite o recolhimento dos equipamentos de ${
              selectedPatient?.name ?? 'o paciente'
            }.`}
          />
        ) : (
          <h3 style={{ color: PrimaryTitleGray }}>
            Confirme o pedido de Recolhimento
          </h3>
        )}
        <Panel style={{ padding: '20px' }}>
          {step === 0 ? (
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <div style={{ display: 'flex', gap: '10px' }}>
                <Tooltip title="Validação e Processamento de Pedidos">
                  <SecondaryButton
                    onClick={async () => {
                      selectGenericEquipment();
                      setStep(1);
                      moveNextToResumeGeneric();
                    }}
                    style={{
                      boxSizing: 'border-box',
                      height: '30px',
                    }}
                    disabled={isLoading}
                  >
                    <ArrowForward />
                  </SecondaryButton>
                </Tooltip>
                <PrimaryButton
                  style={{ textAlign: 'right', marginBottom: '15px' }}
                  onClick={() => setStep(1)}
                  disabled={!shouldShowProceed()}
                >
                  Prosseguir
                </PrimaryButton>
              </div>
            </div>
          ) : (
            <h4
              style={{
                fontWeight: 'bold',
                padding: '0',
                margin: '0',
                marginBottom: '15px',
              }}
            >
              {selectedPatient.name} - CPF: {formatCPF(selectedPatient.cpf)}
            </h4>
          )}

          {step === 0 ? configCollection() : confirmChanges()}
        </Panel>
      </LargeTile>
    </>
  );
};

export const EquipmentCollectionPage = () => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });

  return (
    <WideLayout
      outlet={isTabletOrMobile ? MainPanels() : MainPanels()}
    ></WideLayout>
  );
};
